var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { ErrorType } from "../types/ErrorType";
/**
 * Narrows a caught value to the optional ky error fields, so callers can read
 * `response`, `status` and `message` without casting to `any`.
 *
 * @param error the caught value
 * @returns the value viewed as {@link ErrorWithResponse}, or `undefined` when it is not an object
 */
export var toErrorWithResponse = function (error) {
    return typeof error === "object" && error !== null
        ? error
        : undefined;
};
var HTTP_FORBIDDEN = 403;
/** react-query's default number of retries of a failed query. */
var DEFAULT_QUERY_RETRIES = 3;
/**
 * True when the caught value is an HTTP 403 response — the user may not read
 * the record (e.g. a Distributor opening a private product).
 *
 * @param error the caught value
 * @returns whether the request was rejected with 403 Forbidden
 */
export var isForbiddenError = function (error) { var _a, _b; return ((_b = (_a = toErrorWithResponse(error)) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status) === HTTP_FORBIDDEN; };
/**
 * react-query `retry` option that keeps the default retries but gives up at
 * once on 403 — retrying cannot change a permission decision.
 *
 * @param failureCount number of failures so far
 * @param error the last error
 * @returns whether to retry the query
 */
export var retryUnlessForbidden = function (failureCount, error) { return !isForbiddenError(error) && failureCount < DEFAULT_QUERY_RETRIES; };
/**
 * Translation ids of backend error types that mean the same thing wherever
 * they come from, used as a fallback when a screen has no message of its own.
 */
var API_ERROR_MESSAGE_IDS = (_a = {},
    _a[ErrorType.FILTER_NOT_ALLOWED_FOR_PUBLIC_ONLY_VIEW] = "ui-br-agency.error.filterNotAllowedForPublicOnlyView",
    _a);
/**
 * Maps a backend error type (e.g. "-92") to its generic translation id.
 *
 * @param code the `type` of the first error of an error response
 * @returns the translation id, or `undefined` when the type has no generic message
 */
export var resolveApiErrorMessageId = function (code) {
    return code ? API_ERROR_MESSAGE_IDS[code] : undefined;
};
/**
 * Reads the error type of the first error of a failed ky request. The body is
 * read from a clone, so the same error can still be read by another consumer.
 *
 * @param error the caught value
 * @returns the error type, or `undefined` when there is no readable error body
 */
export var readApiErrorType = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var response, readable, body, _a;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                response = (_b = toErrorWithResponse(error)) === null || _b === void 0 ? void 0 : _b.response;
                if (!response)
                    return [2 /*return*/, undefined];
                _f.label = 1;
            case 1:
                _f.trys.push([1, 3, , 4]);
                readable = typeof response.clone === "function" ? response.clone() : response;
                if (typeof readable.json !== "function")
                    return [2 /*return*/, undefined];
                return [4 /*yield*/, readable.json()];
            case 2:
                body = (_f.sent());
                return [2 /*return*/, (_e = (_d = (_c = body === null || body === void 0 ? void 0 : body.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.type) !== null && _e !== void 0 ? _e : undefined];
            case 3:
                _a = _f.sent();
                return [2 /*return*/, undefined];
            case 4: return [2 /*return*/];
        }
    });
}); };
